<p-toast></p-toast>

<div class="auth-container-login">
    <!-- Left Side - Background Image -->
    <div class="auth-left">
        <img
            src="assets/layout/images/bgimage.png"
            alt="Background"
            class="background-image"
        />
        <div class="background-overlay">
            <div class="welcome-content">
                <h1>Secure Access</h1>
                <p>Verify Your Email</p>
            </div>
        </div>
    </div>

    <!-- Right Side - Forgot Password Form -->
    <div class="auth-right">
        <div class="form-container">
            <div class="logo-section">
                <div class="logo-row">
                    <img
                        src="assets/layout/images/wow-care-logo-new.png"
                        alt="WowCare Logo"
                        class="logo"
                    />
                    <span class="brand-text">WowCare</span>
                </div>
                <h3>Verify Email Change</h3>
                <p>
                    Confirm your email has been changed by clicking the button
                    below.
                </p>
            </div>

            <div class="auth-form">
                <div class="form-actions">
                    <button
                        pButton
                        label="Confirm Email Change"
                        [loading]="loading"
                        class="auth-button"
                        (click)="onConfirm()"
                    ></button>
                </div>

                <div class="auth-links">
                    <a routerLink="/login" class="back-link">← Back to Login</a>
                </div>
            </div>

            <div
                class="app-buttons"
                style="
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    gap: 20px;
                    margin-top: 30px;
                "
            >
                <a
                    href="https://apps.apple.com/us/app/wowcare/id6630378434"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="assets/layout/images/appstoreplay.png"
                        alt="App Store"
                        class="app-button"
                        style="
                            height: 3rem;
                            cursor: pointer;
                            transition: transform 0.2s ease;
                        "
                        onmouseover="this.style.transform = 'scale(1.05)'"
                        onmouseout="this.style.transform = 'scale(1)'"
                    />
                </a>
                <a
                    href="https://play.google.com/store/apps/details?id=com.wiseowlworld.schoolerpwowapp"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <img
                        src="assets/layout/images/googleplay.jpg"
                        alt="Google Play"
                        class="app-button"
                        style="
                            height: 3rem;
                            cursor: pointer;
                            transition: transform 0.2s ease;
                        "
                        onmouseover="this.style.transform = 'scale(1.05)'"
                        onmouseout="this.style.transform = 'scale(1)'"
                    />
                </a>
            </div>
        </div>
    </div>
</div>
